import Event from '../../core/Event';

export default class ResetPasswordDone extends Event {
    public static type = 'ResetPasswordDone';

    constructor(public readonly password: string) {
        super(ResetPasswordDone.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/ResetPasswordDone.ts